
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";

interface Testimonial {
  id: number;
  quote: string;
  author: string;
  role: string;
  company: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    quote: "OrderSales.AI:n tekoäly on muuttanut täysin tapaamme hallita tuotevalikoimaa. Olemme vähentäneet varaston loppumisia 73% samalla kun olemme laskeneet kokonaisvarastokustannuksia.",
    author: "Sari Virtanen",
    role: "Toiminnanjohtaja",
    company: "Verkkokauppa Oy"
  },
  {
    id: 2,
    quote: "Räätälöity tekoälyagentti ymmärtää asiakkaamme paremmin kuin me joskus! Se on auttanut meitä kasvattamaan lisämyyntiä 42% vain kolmessa kuukaudessa.",
    author: "Mikko Laine",
    role: "Myyntijohtaja",
    company: "TechStore Finland"
  },
  {
    id: 3,
    quote: "Käyttöönotto oli sujuvaa ja ROI oli lähes välitön. Myyntitiimillämme on nyt tekoälykumppani, joka tuntee jokaisen yksityiskohdan tuotevalikoimastamme.",
    author: "Jenni Korhonen",
    role: "Verkkokauppapäällikkö",
    company: "Digital Nordic"
  },
  {
    id: 4,
    quote: "Pienenä verkkokauppana meillä ei ollut varaa laajaan henkilöstöön syvällä tuotetuntemuksella. OrderSales.AI:n tekoäly on tasannut pelikentän meille.",
    author: "Timo Laaksonen",
    role: "Omistaja",
    company: "Laaksonen Verkkokauppa"
  },
  {
    id: 5,
    quote: "Personointiominaisuudet ovat uskomattomia. Asiakkaamme kokevat saavansa asiantuntija-apua räätälöitynä juuri heidän tarpeisiinsa ja budjettiin.",
    author: "Aino Mäkinen",
    role: "Asiakaskokemuspäällikkö",
    company: "Future Commerce"
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="section bg-white">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="wallpaper-subtitle mb-6">
            Luotettu johtavien <span className="gradient-text">Verkkokauppojen</span> toimesta
          </h2>
          <p className="text-wallpaper-gray max-w-2xl mx-auto font-wallpaper">
            Kuule suoraan verkkokaupoilta, jotka ovat muuttaneet liiketoimintansa 
            räätälöidyillä tekoälyratkaisuillamme.
          </p>
        </div>

        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent>
            {testimonials.map((testimonial) => (
              <CarouselItem key={testimonial.id} className="md:basis-1/2 lg:basis-1/3 pl-4">
                <TestimonialCard testimonial={testimonial} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center mt-10">
            <CarouselPrevious className="static mr-4 translate-x-0 translate-y-0 border-wallpaper-lightGray text-wallpaper-darkGray rounded-none" />
            <CarouselNext className="static ml-4 translate-x-0 translate-y-0 border-wallpaper-lightGray text-wallpaper-darkGray rounded-none" />
          </div>
        </Carousel>

        <div className="mt-20 flex flex-wrap justify-center items-center gap-8 md:gap-16">
          <LogoPlaceholder text="TechStore" />
          <LogoPlaceholder text="Verkkokauppa" />
          <LogoPlaceholder text="Digital Nordic" />
          <LogoPlaceholder text="Laaksonen" />
          <LogoPlaceholder text="Future Commerce" />
        </div>
      </div>
    </section>
  );
};

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  return (
    <Card className="luxury-card h-full border border-wallpaper-lightGray rounded-none">
      <CardContent className="p-8">
        <Quote className="text-wallpaper-lightGray h-8 w-8 mb-6" />
        <p className="text-wallpaper-darkGray mb-8 font-wallpaper text-sm leading-relaxed">{testimonial.quote}</p>
        <div>
          <p className="font-wallpaper text-sm uppercase tracking-wider">{testimonial.author}</p>
          <p className="text-xs text-wallpaper-gray font-wallpaper mt-1">
            {testimonial.role}, {testimonial.company}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

const LogoPlaceholder = ({ text }: { text: string }) => {
  return (
    <div className="h-10 px-6 border border-wallpaper-lightGray bg-white shadow-sm flex items-center justify-center hover:border-wallpaper-darkGray/30 transition-colors duration-300">
      <span className="font-wallpaper text-xs tracking-widest uppercase text-wallpaper-gray">
        {text}
      </span>
    </div>
  );
};

export default Testimonials;
